import axios from 'axios';
import Config from '../../misc/Config';

const API_URL = Config.GFU_API_URL + '/offer-logs';

const state = {
    currentLog: null,
};

const actions = {
    async logOfferRequest({ commit, state }, data) {
        const response = state.currentLog && state.currentLog.id 
            ? await axios.patch(`${API_URL}/${state.currentLog.id}`, data)
            : await axios.post(API_URL, data);
        commit('setCurrentLog', response.data);
    }
};
const mutations = {
    setCurrentLog: (state, log) => state.currentLog = log,
};

export default {
    state,
    actions,
    mutations,
};